module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "Contents-A"
    }
  })]), _c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _c('div', [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }, [_c('p', {
    staticClass: "ct"
  })]), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game#toc_marker-1"
    }
  }, [_vm._v("This Isn’t a Game")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game1#toc_marker-2"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/#toc_marker-3"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game3#toc_marker-4"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game4#toc_marker-5"
    }
  }, [_vm._v("Thursday")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game5#toc_marker-6"
    }
  }, [_vm._v("Saturday")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game6#toc_marker-7"
    }
  }, [_vm._v("Monday")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game7#toc_marker-8"
    }
  }, [_vm._v("Tuesday")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game8#toc_marker-9"
    }
  }, [_vm._v("Tuesday, 1:43 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game9#toc_marker-10"
    }
  }, [_vm._v("Tuesday, 2:52 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game10#toc_marker-11"
    }
  }, [_vm._v("Tuesday, 3:26 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game11#toc_marker-12"
    }
  }, [_vm._v("Tuesday, 4:32 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game12#toc_marker-13"
    }
  }, [_vm._v("Tuesday, 5:02 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game13#toc_marker-14"
    }
  }, [_vm._v("Tuesday, 6:10 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game14#toc_marker-15"
    }
  }, [_vm._v("Tuesday, 6:45 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game15#toc_marker-16"
    }
  }, [_vm._v("Wednesday, 7:45 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game16#toc_marker-17"
    }
  }, [_vm._v("Wednesday, 9:30 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game17#toc_marker-18"
    }
  }, [_vm._v("Wednesday, 11:45 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game18#toc_marker-19"
    }
  }, [_vm._v("Wednesday, 1:15 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game19#toc_marker-20"
    }
  }, [_vm._v("Wednesday, 1:48 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game20#toc_marker-21"
    }
  }, [_vm._v("Wednesday, 2:59 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game21#toc_marker-22"
    }
  }, [_vm._v("Wednesday, 3:48 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game22#toc_marker-23"
    }
  }, [_vm._v("Wednesday, 6:36 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game23#toc_marker-24"
    }
  }, [_vm._v("Wednesday, 8:19 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game24#toc_marker-25"
    }
  }, [_vm._v("Wednesday, 9:23 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game25#toc_marker-26"
    }
  }, [_vm._v("Wednesday, 10:17 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game26#toc_marker-27"
    }
  }, [_vm._v("Thursday, 5:45 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game27#toc_marker-28"
    }
  }, [_vm._v("Thursday, 7:03 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game28#toc_marker-29"
    }
  }, [_vm._v("Thursday, 8:25 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game29#toc_marker-30"
    }
  }, [_vm._v("Thursday, 9:44 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game30#toc_marker-31"
    }
  }, [_vm._v("Thursday, 10:02 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game31#toc_marker-32"
    }
  }, [_vm._v("Thursday, 10:57 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game32#toc_marker-33"
    }
  }, [_vm._v("Thursday, 11:33 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game33#toc_marker-34"
    }
  }, [_vm._v("Thursday, 12:36 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game34#toc_marker-35"
    }
  }, [_vm._v("Thursday, 1:07 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game35#toc_marker-36"
    }
  }, [_vm._v("Thursday, 1:45 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game36#toc_marker-37"
    }
  }, [_vm._v("Thursday, 2:33 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game37#toc_marker-38"
    }
  }, [_vm._v("Friday, 6:30 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game38#toc_marker-39"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game39#toc_marker-40"
    }
  }, [_vm._v("More from this Author")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/This_Isn't_A_Game40#toc_marker-41"
    }
  }, [_vm._v("Contact Us")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88feafcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/This_Isnt_A_Game-2.vue
// module id = 63
// module chunks = 0